import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import { AnimatedBox } from '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import React__default from 'react';
import ReactDOM from 'react-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { ModalContext } from './ModalContext.js';
var ModalWrapper = styled(Box)(css({
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  top: "0",
  left: "0",
  height: "100vh",
  width: "100vw",
  zIndex: "modal"
}), {
  height: "-webkit-fill-available"
});
var ModalOverlay = styled(AnimatedBox)(css({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  backgroundColor: "modalOverlayBackground",
  opacity: "0.95"
}));
var ModalGlobalStyle = createGlobalStyle({
  body: {
    overflow: "hidden !important"
  }
});
var Modal = function Modal(_a) {
  var children = _a.children,
    onClose = _a.onClose,
    isAnimated = _a.isAnimated,
    _b = _a.hasInitialAnimation,
    hasInitialAnimation = _b === void 0 ? true : _b,
    _c = _a.hasExitAnimation,
    hasExitAnimation = _c === void 0 ? true : _c,
    _d = _a.closeOnOverlayClick,
    closeOnOverlayClick = _d === void 0 ? false : _d;
  var contextValue = React__default.useMemo(function () {
    return {
      onClose: onClose,
      isAnimated: isAnimated,
      hasInitialAnimation: hasInitialAnimation,
      hasExitAnimation: hasExitAnimation
    };
  }, [hasExitAnimation, hasInitialAnimation, isAnimated, onClose]);
  if (typeof document !== "undefined") {
    return ReactDOM.createPortal(React__default.createElement(ModalWrapper, null, React__default.createElement(ModalGlobalStyle, null), React__default.createElement(ModalOverlay, {
      onClick: closeOnOverlayClick ? onClose : undefined,
      variants: {
        exit: {
          opacity: 0
        },
        enter: {
          opacity: 0.95
        }
      },
      initial: hasInitialAnimation ? "exit" : "enter",
      animate: "enter",
      exit: hasExitAnimation ? "exit" : "enter",
      transition: {
        ease: "easeOut",
        duration: isAnimated ? 0.2 : 0
      }
    }), React__default.createElement(ModalContext.Provider, {
      value: contextValue
    }, children)), document.body);
  }
  return null;
};
export { Modal };